import { Component, OnInit } from '@angular/core';
import { LocationStrategy } from '@angular/common';
import { Router } from '@angular/router';
import { Headers } from '@angular/http';

import { TransferenciaComponent } from 'app/transferencia/transferencia.component';
import { MainService } from 'app/resources/services/index';
import { DefineBootboxId } from 'app/resources/classes/index';
import 'bootbox';


@Component({
  selector: 'app-bancaria',
  templateUrl: './bancaria.component.html'
})
export class BancariaComponent implements OnInit {

  public readonly newFavorecido = 'Nova Conta';
  public conta: any;
  public processando: boolean;
  public bancos: any;
  public tarifa: any;
  public indiceConversaoMoeda: any;
  public tarifaBancaria: any;
  public transferencia: any = { conta: { poupanca: undefined } };
  public valorPontos: number;
  public epwd: string;
  public documentoTipo: any = 'CPF';
  public contasValidas: Array<any> = [];
  public contaSelecionada: any = undefined;
  public inputReady: boolean;
  public contasValidasReady: boolean;
  public limiteMaximoTransferencia: any = undefined;
  public limiteMinimoTransferencia: any = undefined;
  public contaRecebida: any;
  public bootboxAlertComId: DefineBootboxId = new DefineBootboxId();

  public location: LocationStrategy;

  constructor(public mainService: MainService, public router: Router,
    location: LocationStrategy) {
  }

  ngOnInit() {
    window.scrollTo(0, 0);
    this.processando = false;
    this.valorPontos = 0;
    this.epwd = '';
    this.inputReady = false;
    this.contasValidasReady = true;

    this.contaRecebida = this.newFavorecido;

    const lista = document.getElementsByName('transferenciaSelect');

    this.contasValidas = this.mainService.servicesService.contas;

    this.conta = {
      valorMoeda: '',
      titularNome: '',
      titularDocumento: '',
      agencia: '',
      agenciaDigito: '',
      numero: '',
      numeroDigito: '',
      poupanca: undefined,
      banco: { codigo: '', id: '' }
    };

    this.mainService.http.pathRest().get('cartao/transferencia/bancaria/tarifa/', true)
      .subscribe(
        sucesso => {
          this.tarifa = sucesso.json();

          this.mainService.http.pathRest().get('cartao/current/indice/', true)
            .subscribe(
              data => {
                this.indiceConversaoMoeda = data.json();
                this.calculaValorPontos();
              }, error => {
              }
            );
        }, error => {
        }
      );

    this.mainService.http.pathV2().get('auth/users/transferencias/bancarias/limite/maximo/', true)
      .subscribe(
        sucesso => { this.limiteMaximoTransferencia = parseInt(sucesso.json(), 10); },
        error => { });

    this.mainService.http.pathV2().get('auth/users/transferencias/bancarias/limite/minimo/', true)
      .subscribe(
        sucesso => { this.limiteMinimoTransferencia = parseInt(sucesso.json(), 10); },
        error => { });

    this.mainService.http.pathRest().get('cartao/current/tarifa/transferencias/', true)
      .subscribe(
        sucesso => this.tarifaBancaria = sucesso.json(),
        error => { }
      );

    this.mainService.http.pathRest().get('enum/bancos/', true)
      .subscribe(
        sucesso => this.bancos = sucesso.json(),
        error => { }
      );

    if (this.contasValidas) {
      this.contasValidasReady = false;
    }

    this.mainService.saldoService.initialize();

  }

  public setAccount(conta) {
    this.conta.banco = conta
  }

  public isFavorecido() {
    return this.contaRecebida === this.newFavorecido;
  }

  public calculaValorPontos() {
    this.valorPontos = this.mainService.servicesService.moedaToPontos(
      this.conta.valorMoeda, this.indiceConversaoMoeda) + this.tarifa;
  };

  public saveBancaria() {
    if (this.conta.titularNome.length === 0) {
      this.bootboxAlertComId.alerta('O campo nome completo é de preenchimento obrigatório');
    } else if (this.conta.titularDocumento.length === 0) {
      this.bootboxAlertComId.alerta('O campo documento é de preenchimento obrigatório');
    } else if (this.conta.agencia.length === 0) {
      this.bootboxAlertComId.alerta('O campo número da agencia é de preenchimento obrigatório');
    } else if (this.conta.valorMoeda.length === 0) {
      this.bootboxAlertComId.alerta('Informe o valor que será transferido');
    } else if (this.documentoTipo == 'CNPJ' && this.conta.titularDocumento.length != 14) {
      this.bootboxAlertComId.alerta('Verifique o documento preenchimento');
    } else if (this.conta.poupanca === undefined || this.conta.poupanca === null) {
      this.bootboxAlertComId.alerta('Informe se a conta é Corrente ou Poupança');
    } else if (this.conta.valorMoeda < this.limiteMinimoTransferencia) {
      this.bootboxAlertComId.alerta('O valor da transferência deve ser maior ou igual ao valor minimo!');
    } else if (this.conta.valorMoeda > this.limiteMaximoTransferencia) {
      this.bootboxAlertComId.alerta('O valor da transferencia ultrapassa o máximo permitido!');
    } else {
      const url = 'cartao/transferencia/bancaria/';
      this.calculaValorPontos();
      this.processando = true;
      this.transferencia.conta = this.conta;
      this.transferencia.valorMoeda = this.conta.valorMoeda;
      const cabecalho: Headers = new Headers();
      cabecalho.append('Authorization', 'Basic ' + this.mainService.sessionService.getAuthBasic());
      cabecalho.append('X-Auth-Ep', this.epwd);
      this.mainService.http.pathRest().post(url, this.transferencia, true, cabecalho)
        .subscribe(
          sucesso => {
            this.mainService.saldoService.initialize();
            this.router.navigate(['/transferencias']);
            this.processando = false;
            this.bootboxAlertComId.alerta('A transferência bancária foi realizada com sucesso!');
          },
          error => {
            this.bootboxAlertComId.alerta(error._body);
            this.processando = false;
          });
    }
  };

  public selecionarConta() {
    this.conta = this.contaRecebida;
    if (this.conta === this.newFavorecido) {
      this.conta = {
        valorMoeda: '',
        titularNome: '',
        titularDocumento: '',
        agencia: '',
        agenciaDigito: '',
        numero: '',
        numeroDigito: '',
        poupanca: undefined,
        banco: { codigo: '' }
      };
      this.inputReady = false;
    }
    if (this.conta !== undefined && this.conta !== '' && this.conta !== null) {
      if (this.conta.titularDocumento.length === 14) {
        this.documentoTipo = 'CNPJ';
        this.inputReady = true;
      } else if (this.conta.titularDocumento.length === 11) {
        this.documentoTipo = 'CPF';
        this.inputReady = true;
      }
    } else {
      this.documentoTipo = 'CPF';
      this.inputReady = false;
    }
  }

  public alteraCpf(event) {
    let cpf = event.target.value;
    cpf = cpf.replace(/[^0-9]+/g, '');
    if (!cpf || cpf.length === 0) {
      return '';
    }

    if (cpf.length > 11) {
      return cpf = cpf.substring(0, 11);
    }
    return this.conta.titularDocumento = cpf;
  }
}



// WEBPACK FOOTER //
// ./src/app/transferencia/bancaria/bancaria.component.ts